import React from 'react';
import { MenuItem } from '@mui/material';
import { makeStyles , withStyles } from 'tss-react/mui';
import { generateDayTimeRange, DateObject, TimeRangeGenerator } from '@uplift/services';
import { SelectRaw, SelectProps } from '../Select';


const useTimeSelectStyles = makeStyles()({
  menu: {
    maxHeight: '190px',
  }
});

const TimeMenuItem = withStyles(MenuItem, {
  root: {
    '& span': {
      display: 'inline-block',
      textAlign: 'right',
      width: '72px', // This should be hardcoded to correctly align items
    }
  },
  selected: {
    '.MuiSelect-root & span': {
      textAlign: 'left',
    }
  }
});


export type TimeSelectProps = Pick<SelectProps, 'name' | 'error' | 'helperText'> & {
  label?: React.ReactNode;
  value: string;
  setValue: (value: string) => void;
  onBlur?: () => void;
  showAfter?: DateObject;
  inclusive?: boolean;
  minuteIncrement?: number;
  slotsGenerator?: TimeRangeGenerator;
  color?: 'primary' | 'secondary';
};

export const TimeSelect: React.FC<TimeSelectProps> = ({ slotsGenerator = generateDayTimeRange, ...props }) => {
  const { classes } = useTimeSelectStyles();
  const range = React.useMemo(() => slotsGenerator(props.minuteIncrement, props.inclusive), [ props.inclusive, props.minuteIncrement, slotsGenerator ]);
  const values = React.useMemo(() => {
    return range.map(date => ({
      value: date.format('HH:mm:ss'),
      label: date.format('h:mm A'),
      disabled: props.showAfter && !date.isAfter(props.showAfter),
    }));
  }, [ range, props.showAfter ]);

  return (
    <SelectRaw
      label={props.label}
      name={props.name}
      value={props.value}
      error={props.error}
      helperText={props.helperText}
      onChange={e => props.setValue(e.target.value as string)}
      onBlur={props.onBlur}
      color={props.color}
      MenuProps={{
        classes: {
          list: classes.menu,
        }
      }}
    >
      {values.map(({ value, label, disabled }) => (
        <TimeMenuItem key={value} value={value} disabled={disabled}>
          <span>
            {label}
          </span>
        </TimeMenuItem>
      ))}
    </SelectRaw>
  );
};
